/* Boot World PRO – Corporate Footwear Program (CFP) behaviors.
   Loaded by every CFP section; the guard makes repeated includes harmless. */
(function () {
  if (window.__cfpLoaded) return;
  window.__cfpLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('cfp-js');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* 1. Old single-page anchors (#mobileFootwearStore etc.) -> new pages.
        The map lives on the sub-nav as JSON so it can be edited in the theme editor. */
  function legacyRedirect() {
    var nav = document.querySelector('[data-cfp-legacy]');
    if (!nav || !window.location.hash) return;
    try {
      var map = JSON.parse(nav.getAttribute('data-cfp-legacy'));
      var target = map[window.location.hash.slice(1)];
      if (target && target !== window.location.pathname) window.location.replace(target);
    } catch (e) { /* ignore bad JSON */ }
  }

  /* 2. Keep the active sub-nav tab visible on small screens. */
  function subnavScroll() {
    document.querySelectorAll('.cfp-subnav__list').forEach(function (list) {
      var active = list.querySelector('[aria-current="page"]');
      if (active && list.scrollWidth > list.clientWidth) {
        list.scrollLeft = active.parentNode.offsetLeft - 16;
      }
    });
  }

  /* 3. Reveal-on-scroll + count-up numbers in stat tiles. */
  function countUp(el) {
    var raw = el.getAttribute('data-cfp-count');
    var match = raw && raw.match(/^([^0-9]*)([\d,]+)(.*)$/);
    if (!match || reduceMotion) return;
    var prefix = match[1], suffix = match[3];
    var end = parseInt(match[2].replace(/,/g, ''), 10);
    var useComma = match[2].indexOf(',') > -1;
    // Years like "1975" look silly counting from 0 – start close to the end instead.
    var start = end > 1900 && end < 2100 && !useComma ? end - 40 : 0;
    var t0 = null, dur = 1200;
    function fmt(n) { return useComma ? n.toLocaleString('en-US') : String(n); }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(Math.round(start + (end - start) * eased)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = prefix + fmt(start) + suffix;
    requestAnimationFrame(step);
  }

  function observe() {
    var items = document.querySelectorAll('.cfp-reveal:not(.is-visible), [data-cfp-count]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-visible');
        if (el.hasAttribute('data-cfp-count')) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* 4. Lead form: friendly inline validation before Shopify's contact endpoint. */
  function forms() {
    document.querySelectorAll('form.cfp-form:not([data-cfp-ready])').forEach(function (form) {
      form.setAttribute('data-cfp-ready', '');
      form.setAttribute('novalidate', '');
      function check(field) {
        var input = field.querySelector('input, select, textarea');
        if (!input) return true;
        var ok = input.checkValidity();
        field.classList.toggle('is-invalid', !ok);
        input.setAttribute('aria-invalid', ok ? 'false' : 'true');
        return ok;
      }
      form.querySelectorAll('.cfp-form__field').forEach(function (field) {
        var input = field.querySelector('input, select, textarea');
        if (input) input.addEventListener('blur', function () { if (field.classList.contains('is-invalid') || input.value) check(field); });
      });
      form.addEventListener('submit', function (e) {
        var firstBad = null;
        form.querySelectorAll('.cfp-form__field').forEach(function (field) {
          if (!check(field) && !firstBad) firstBad = field;
        });
        if (firstBad) {
          e.preventDefault();
          var input = firstBad.querySelector('input, select, textarea');
          if (input) input.focus();
          return;
        }
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-sending') || 'Sending…'; }
      });
    });

    // After a successful post Shopify reloads the page with ?contact_posted=true – bring the message into view.
    var status = document.querySelector('.cfp-form__status');
    if (status) status.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* 5. Sticky sub-nav offset: sit below a sticky theme header if there is one. */
  function stickyOffset() {
    var nav = document.querySelector('.cfp-subnav--sticky');
    if (!nav) return;
    var sel = nav.getAttribute('data-header-selector');
    var header = sel ? document.querySelector(sel) : null;
    function update() {
      var h = 0;
      if (header) {
        var pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') h = header.getBoundingClientRect().height;
      }
      document.documentElement.style.setProperty('--cfp-sticky-top', h + 'px');
    }
    update();
    window.addEventListener('resize', update, { passive: true });
  }

  legacyRedirect();
  ready(function () {
    subnavScroll();
    observe();
    forms();
    stickyOffset();
  });

  // Re-run when sections are added/edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function () { observe(); forms(); subnavScroll(); });
})();
